import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "@/pages/home/components/HeroSection";
import HotTicker from "@/pages/home/components/HotTicker";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import LiveFeedSection from "@/pages/home/components/LiveFeedSection";
import CategorySection from "@/pages/home/components/CategorySection";
import VoicesSection from "@/pages/home/components/VoicesSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SubmitCta from "@/pages/home/components/SubmitCta";
import { useSeo } from "@/hooks/useSeo";
import { useScrollToHash } from "@/hooks/useScrollToHash";
import { faqs } from "@/mocks/faqs";
import { SITE_EMAIL, SITE_NAME, SITE_URL } from "@/utils/format";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: `${SITE_URL}/`,
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: `${SITE_URL}/`,
    description:
      "瓜友会网是聚合全网热点的吃瓜资讯站，实时更新今日爆料、热门瓜田与新鲜瓜进展。",
    email: SITE_EMAIL,
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  },
];

export default function Home() {
  useScrollToHash();
  useSeo({
    title: "瓜友会网 | 吃瓜现场 · 今日爆料一手热瓜实时更新",
    description:
      "瓜友会网带你直达吃瓜现场，今日爆料、热门瓜田、新鲜瓜实时滚动更新，覆盖娱乐、网红、情感、职场、科技、综艺等圈层热点，蹲最新进展、看网友热评，一站式满足吃瓜需求。",
    keywords: "瓜友会网,吃瓜现场,今日爆料,热门瓜田,实时吃瓜",
    path: "/",
    jsonLd: homeJsonLd,
  });

  return (
    <div className="flex flex-col min-h-screen bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <HotTicker />
        <FeaturedSection />
        <LiveFeedSection />
        <CategorySection />
        <VoicesSection />
        <FaqSection />
        <SubmitCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}